import { createContext, useState, useContext, useEffect, ReactNode } from 'react';
import { useLocation } from 'wouter';

// Import translation files
import itCommon from '@/locales/it/common.json';
import itNav from '@/locales/it/nav.json';
import itSearch from '@/locales/it/search.json';
import itAuth from '@/locales/it/auth.json';
import itAdmin from '@/locales/it/admin.json';
import itHome from '@/locales/it/home.json';
import itCatalog from '@/locales/it/catalog.json';
import itFilter from '@/locales/it/filter.json';
import itEntity from '@/locales/it/entity.json';
import itEntities from '@/locales/it/entities.json';
import itMap from '@/locales/it/map.json';
import itPhoto from '@/locales/it/photo.json';
import itPhotos from '@/locales/it/photos.json';
import itFavorites from '@/locales/it/favorites.json';
import itBookmarks from '@/locales/it/bookmarks.json';
import itProfile from '@/locales/it/profile.json';
import itFooter from '@/locales/it/footer.json';
import itAbout from '@/locales/it/about.json';
import itEntityTypes from '@/locales/it/entityTypes.json';
import itCarousel from '@/locales/it/carousel.json';
import itValidation from '@/locales/it/validation.json';
import itError from '@/locales/it/error.json';
import itLogin from '@/locales/it/login.json';
import itLicenses from '@/locales/it/licenses.json';
import itPrivacy from '@/locales/it/privacy.json';
import itLicensesPage from '@/locales/it/licenses-page.json';
import itTermsOfService from '@/locales/it/terms-of-service.json';
import itCookies from '@/locales/it/cookies.json';
import itAudioguides from '@/locales/it/audioguides.json';
import itConversionModal from '@/locales/it/conversion_modal.json';
import itBuildings from '@/locales/it/buildings.json';
import itItineraries from '@/locales/it/itineraries.json';
import itEssays from '@/locales/it/essays.json';
import itSupport from '@/locales/it/support.json';
// Il quiz esiste solo in italiano: le rotte /en, /de, /sl non sono registrate
import itQuiz from '@/locales/it/quiz.json';
import itNewsletter from '@/locales/it/newsletter.json';

import enCommon from '@/locales/en/common.json';
import enNav from '@/locales/en/nav.json';
import enSearch from '@/locales/en/search.json';
import enAuth from '@/locales/en/auth.json';
import enAdmin from '@/locales/en/admin.json';
import enHome from '@/locales/en/home.json';
import enCatalog from '@/locales/en/catalog.json';
import enFilter from '@/locales/en/filter.json';
import enEntity from '@/locales/en/entity.json';
import enEntities from '@/locales/en/entities.json';
import enMap from '@/locales/en/map.json';
import enPhoto from '@/locales/en/photo.json';
import enPhotos from '@/locales/en/photos.json';
import enFavorites from '@/locales/en/favorites.json';
import enBookmarks from '@/locales/en/bookmarks.json';
import enProfile from '@/locales/en/profile.json';
import enFooter from '@/locales/en/footer.json';
import enAbout from '@/locales/en/about.json';
import enEntityTypes from '@/locales/en/entityTypes.json';
import enCarousel from '@/locales/en/carousel.json';
import enValidation from '@/locales/en/validation.json';
import enError from '@/locales/en/error.json';
import enLogin from '@/locales/en/login.json';
import enLicenses from '@/locales/en/licenses.json';
import enPrivacy from '@/locales/en/privacy.json';
import enLicensesPage from '@/locales/en/licenses-page.json';
import enTermsOfService from '@/locales/en/terms-of-service.json';
import enCookies from '@/locales/en/cookies.json';
import enAudioguides from '@/locales/en/audioguides.json';
import enConversionModal from '@/locales/en/conversion_modal.json';
import enBuildings from '@/locales/en/buildings.json';
import enItineraries from '@/locales/en/itineraries.json';
import enEssays from '@/locales/en/essays.json';
import enSupport from '@/locales/en/support.json';
import enNewsletter from '@/locales/en/newsletter.json';

import deCommon from '@/locales/de/common.json';
import deNav from '@/locales/de/nav.json';
import deSearch from '@/locales/de/search.json';
import deAuth from '@/locales/de/auth.json';
import deAdmin from '@/locales/de/admin.json';
import deHome from '@/locales/de/home.json';
import deCatalog from '@/locales/de/catalog.json';
import deFilter from '@/locales/de/filter.json';
import deEntity from '@/locales/de/entity.json';
import deEntities from '@/locales/de/entities.json';
import deMap from '@/locales/de/map.json';
import dePhoto from '@/locales/de/photo.json';
import dePhotos from '@/locales/de/photos.json';
import deFavorites from '@/locales/de/favorites.json';
import deBookmarks from '@/locales/de/bookmarks.json';
import deProfile from '@/locales/de/profile.json';
import deFooter from '@/locales/de/footer.json';
import deAbout from '@/locales/de/about.json';
import deEntityTypes from '@/locales/de/entityTypes.json';
import deCarousel from '@/locales/de/carousel.json';
import deValidation from '@/locales/de/validation.json';
import deError from '@/locales/de/error.json';
import deLogin from '@/locales/de/login.json';
import deLicenses from '@/locales/de/licenses.json';
import dePrivacy from '@/locales/de/privacy.json';
import deLicensesPage from '@/locales/de/licenses-page.json';
import deTermsOfService from '@/locales/de/terms-of-service.json';
import deCookies from '@/locales/de/cookies.json';
import deAudioguides from '@/locales/de/audioguides.json';
import deConversionModal from '@/locales/de/conversion_modal.json';
import deBuildings from '@/locales/de/buildings.json';
import deItineraries from '@/locales/de/itineraries.json';
import deEssays from '@/locales/de/essays.json';
import deSupport from '@/locales/de/support.json';
import deNewsletter from '@/locales/de/newsletter.json';

import slCommon from '@/locales/sl/common.json';
import slNav from '@/locales/sl/nav.json';
import slSearch from '@/locales/sl/search.json';
import slAuth from '@/locales/sl/auth.json';
import slAdmin from '@/locales/sl/admin.json';
import slHome from '@/locales/sl/home.json';
import slCatalog from '@/locales/sl/catalog.json';
import slFilter from '@/locales/sl/filter.json';
import slEntity from '@/locales/sl/entity.json';
import slEntities from '@/locales/sl/entities.json';
import slMap from '@/locales/sl/map.json';
import slPhoto from '@/locales/sl/photo.json';
import slPhotos from '@/locales/sl/photos.json';
import slFavorites from '@/locales/sl/favorites.json';
import slBookmarks from '@/locales/sl/bookmarks.json';
import slProfile from '@/locales/sl/profile.json';
import slFooter from '@/locales/sl/footer.json';
import slAbout from '@/locales/sl/about.json';
import slEntityTypes from '@/locales/sl/entityTypes.json';
import slCarousel from '@/locales/sl/carousel.json';
import slValidation from '@/locales/sl/validation.json';
import slError from '@/locales/sl/error.json';
import slLogin from '@/locales/sl/login.json';
import slLicenses from '@/locales/sl/licenses.json';
import slPrivacy from '@/locales/sl/privacy.json';
import slLicensesPage from '@/locales/sl/licenses-page.json';
import slTermsOfService from '@/locales/sl/terms-of-service.json';
import slCookies from '@/locales/sl/cookies.json';
import slAudioguides from '@/locales/sl/audioguides.json';
import slConversionModal from '@/locales/sl/conversion_modal.json';
import slBuildings from '@/locales/sl/buildings.json';
import slItineraries from '@/locales/sl/itineraries.json';
import slEssays from '@/locales/sl/essays.json';
import slSupport from '@/locales/sl/support.json';
import slNewsletter from '@/locales/sl/newsletter.json';

// Supported languages
type Language = 'it' | 'en' | 'de' | 'sl';

// Translation dictionary type
interface Translations {
  [key: string]: {
    [key in Language]: string;
  };
}

interface I18nContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string, params?: Record<string, string | number>) => string;
}

// Combine all translation namespaces into a single flat dictionary
const createTranslations = (): Translations => {
  const result: Translations = {};
  
  // Helper function to merge namespace into translations with nested support
  const mergeNamespace = (namespace: string, it: any, en: any, de: any, sl: any) => {
    const processObject = (obj: any, prefix: string = '', itObj: any = it, enObj: any = en, deObj: any = de, slObj: any = sl) => {
      Object.keys(obj).forEach((key) => {
        const fullKey = prefix ? `${prefix}.${key}` : key;
        const fullNamespaceKey = `${namespace}.${fullKey}`;
        
        if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
          // Recursively process nested objects
          processObject(obj[key], fullKey, itObj[key], enObj[key], deObj[key], slObj[key]);
        } else {
          // Add the translation
          result[fullNamespaceKey] = {
            it: itObj[key] || '',
            en: enObj[key] || '',
            de: deObj[key] || '',
            sl: slObj[key] || ''
          };
        }
      });
    };
    
    processObject(it);
  };
  
  // Merge all namespaces
  mergeNamespace('common', itCommon, enCommon, deCommon, slCommon);
  mergeNamespace('nav', itNav, enNav, deNav, slNav);
  mergeNamespace('search', itSearch, enSearch, deSearch, slSearch);
  mergeNamespace('auth', itAuth, enAuth, deAuth, slAuth);
  mergeNamespace('admin', itAdmin, enAdmin, deAdmin, slAdmin);
  mergeNamespace('home', itHome, enHome, deHome, slHome);
  mergeNamespace('catalog', itCatalog, enCatalog, deCatalog, slCatalog);
  mergeNamespace('filter', itFilter, enFilter, deFilter, slFilter);
  mergeNamespace('entity', itEntity, enEntity, deEntity, slEntity);
  mergeNamespace('entities', itEntities, enEntities, deEntities, slEntities);
  mergeNamespace('map', itMap, enMap, deMap, slMap);
  mergeNamespace('photo', itPhoto, enPhoto, dePhoto, slPhoto);
  mergeNamespace('photos', itPhotos, enPhotos, dePhotos, slPhotos);
  mergeNamespace('favorites', itFavorites, enFavorites, deFavorites, slFavorites);
  mergeNamespace('bookmarks', itBookmarks, enBookmarks, deBookmarks, slBookmarks);
  mergeNamespace('profile', itProfile, enProfile, deProfile, slProfile);
  mergeNamespace('footer', itFooter, enFooter, deFooter, slFooter);
  mergeNamespace('about', itAbout, enAbout, deAbout, slAbout);
  mergeNamespace('entityTypes', itEntityTypes, enEntityTypes, deEntityTypes, slEntityTypes);
  mergeNamespace('carousel', itCarousel, enCarousel, deCarousel, slCarousel);
  mergeNamespace('validation', itValidation, enValidation, deValidation, slValidation);
  mergeNamespace('error', itError, enError, deError, slError);
  mergeNamespace('login', itLogin, enLogin, deLogin, slLogin);
  mergeNamespace('licenses', itLicenses, enLicenses, deLicenses, slLicenses);
  mergeNamespace('privacy', itPrivacy, enPrivacy, dePrivacy, slPrivacy);
  mergeNamespace('licensesPage', itLicensesPage, enLicensesPage, deLicensesPage, slLicensesPage);
  mergeNamespace('termsOfService', itTermsOfService, enTermsOfService, deTermsOfService, slTermsOfService);
  mergeNamespace('cookies', itCookies, enCookies, deCookies, slCookies);
  mergeNamespace('audioguides', itAudioguides, enAudioguides, deAudioguides, slAudioguides);
  mergeNamespace('modal.conversion', itConversionModal, enConversionModal, deConversionModal, slConversionModal);
  mergeNamespace('buildings', itBuildings, enBuildings, deBuildings, slBuildings);
  mergeNamespace('itineraries', itItineraries, enItineraries, deItineraries, slItineraries);
  mergeNamespace('essays', itEssays, enEssays, deEssays, slEssays);
  mergeNamespace('support', itSupport, enSupport, deSupport, slSupport);
  mergeNamespace('quiz', itQuiz, itQuiz, itQuiz, itQuiz);
  mergeNamespace('newsletter', itNewsletter, enNewsletter, deNewsletter, slNewsletter);

  return result;
};

// Base translations dictionary
const translations: Translations = createTranslations();

// Log statistics about loaded translations
console.log(`✅ I18n: Loaded ${Object.keys(translations).length} translation keys for 4 languages (it, en, de, sl)`);

// Helper per gestire cookie lingua
function setLanguageCookie(lang: Language) {
  document.cookie = `preferred_language=${lang}; path=/; max-age=31536000; SameSite=Lax`;
}

function getLanguageCookie(): Language | null {
  const match = document.cookie.match(/preferred_language=([^;]+)/);
  if (match && ['it', 'en', 'de', 'sl'].includes(match[1])) {
    return match[1] as Language;
  }
  return null;
}

// Create context
export const I18nContext = createContext<I18nContextType | undefined>(undefined);

export function I18nProvider({ children, initialLanguage }: { children: ReactNode; initialLanguage?: Language }) {
  const [location] = useLocation();

  const [language, setLanguage] = useState<Language>(() => {
    // SSR: il server passa il locale; sul client le pagine SSR-ate leggono __SSR_LOCALE__ (parità col server)
    if (initialLanguage) return initialLanguage;
    if (typeof window === 'undefined') return 'it';
    const ssrLocale = (window as any).__SSR_LOCALE__ as Language | undefined;
    if (ssrLocale === 'it' || ssrLocale === 'en' || ssrLocale === 'de' || ssrLocale === 'sl') return ssrLocale;
    // PRIORITÀ 1: Rileva lingua dall'URL se presente
    const urlMatch = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
    if (urlMatch) {
      const urlLang = urlMatch[1];
      if (urlLang === 'it' || urlLang === 'en' || urlLang === 'de' || urlLang === 'sl') {
        return urlLang;
      }
    }
    
    // PRIORITÀ 2: Cookie
    const cookieLang = getLanguageCookie();
    if (cookieLang) {
      return cookieLang;
    }
    
    // PRIORITÀ 3: localStorage (backward compatibility)
    const storedLanguage = localStorage.getItem('language') as Language | null;
    if (storedLanguage && (storedLanguage === 'it' || storedLanguage === 'en' || storedLanguage === 'de' || storedLanguage === 'sl')) {
      return storedLanguage;
    }
    
    // PRIORITÀ 4: Default italiano
    return 'it';
  });

  // Translate function with parameter support
  const t = (key: string, params?: Record<string, string | number>): string => {
    // Get the base translation string
    let translatedText = "";
    
    if (translations[key] && translations[key][language]) {
      translatedText = translations[key][language];
    } else if (translations[key] && translations[key]['it']) {
      // Fallback to Italian if the key exists but not for the current language
      translatedText = translations[key]['it'];
    } else {
      // Return the key itself if no translation found
      console.warn(`Translation missing for key: ${key}`);
      return key;
    }
    
    // If no params provided, return the translation as is
    if (!params) {
      return translatedText;
    }
    
    // Replace parameters in the format {paramName}
    return Object.entries(params).reduce((text, [paramKey, paramValue]) => {
      return text.replace(new RegExp(`\\{${paramKey}\\}`, 'g'), paramValue.toString());
    }, translatedText);
  };

  // Sincronizza lingua quando l'URL cambia
  useEffect(() => {
    const urlMatch = location.match(/^\/([a-z]{2})(\/|$)/);
    if (urlMatch) {
      const urlLang = urlMatch[1];
      if ((urlLang === 'it' || urlLang === 'en' || urlLang === 'de' || urlLang === 'sl') && urlLang !== language) {
        setLanguage(urlLang);
      }
    } else if (location === '/') {
      // Se siamo sulla home page senza prefisso lingua, usa il cookie se disponibile
      const cookieLang = getLanguageCookie();
      if (cookieLang && cookieLang !== language) {
        setLanguage(cookieLang);
      }
    }
  }, [location]);

  // Store language preference in localStorage and cookie when it changes
  useEffect(() => {
    // Salva in entrambe le posizioni per compatibilità
    localStorage.setItem('language', language);
    setLanguageCookie(language);
    
    // Update HTML lang attribute
    document.documentElement.setAttribute('lang', language);
  }, [language]);

  return (
    <I18nContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </I18nContext.Provider>
  );
}

// Custom hook to use the I18n context
export function useI18n() {
  const context = useContext(I18nContext);
  
  if (context === undefined) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  
  return context;
}
